/* Copyright 2013 - 2024 Waiterio LLC */
/* istanbul ignore file */
import getAppUrl from '@waiterio/shared/getAppUrl.js'

export default function getBaseUrl() {
  return getAppUrl()
}
